export function navDropdownMenu() {
  const navContainer = document.querySelector('.l-intro__nav');
  const dropdownToggles = navContainer.querySelectorAll('.js-dropdown-toggle');

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // ドロップダウンメニューのトグル
  dropdownToggles.forEach(toggle => {
    const dropdownId = toggle.getAttribute('data-dropdown');
    const dropdownMenu = document.getElementById(dropdownId);

    // タッチデバイスの場合はクリックイベントを追加
    if (isTouchDevice) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = dropdownMenu.classList.contains('is-open');
        closeAllDropdowns(dropdownId);
        if (!isOpen) {
          dropdownMenu.classList.add('is-open');
          dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
        }
      });
    } else {
      // マウスオーバーの場合はマウスオーバーイベントを追加
      toggle.addEventListener('mouseenter', () => {
        closeAllDropdowns(dropdownId);
        dropdownMenu.classList.add('is-open');
        dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
      });

      toggle.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!dropdownMenu.matches(':hover')) {
            dropdownMenu.classList.remove('is-open');
            dropdownMenu.style.maxHeight = '0';
          }
        }, 100);
      });

      dropdownMenu.addEventListener('mouseleave', () => {
        dropdownMenu.classList.remove('is-open');
        dropdownMenu.style.maxHeight = '0';
      });

      dropdownMenu.addEventListener('mouseenter', () => {
        dropdownMenu.classList.add('is-open');
        dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
      });
    }
  });

  // ドロップダウンメニューの外側をクリックしたら閉じる
  document.addEventListener('click', (e) => {
    if (!navContainer.contains(e.target)) {
      closeAllDropdowns();
    }
  });

  // ドロップダウンメニューを閉じる
  function closeAllDropdowns(excludeId) {
    dropdownToggles.forEach(toggle => {
      const dropdownId = toggle.getAttribute('data-dropdown');
      if (!excludeId || dropdownId !== excludeId) {
        const dropdownMenu = document.getElementById(dropdownId);
        dropdownMenu.classList.remove('is-open');
        dropdownMenu.style.maxHeight = '0';
      }
    });
  }
}
